export default __webpack_public_path__ + "static/media/robust-classification-healthcare.5696fc69.svg";